import {useEffect} from 'react';

import {Outlet, useLocation} from 'react-router';
import {motion} from 'framer-motion';

import Footer from 'components/footer';
import {wholesalerMenus} from 'utilities/helper/wholesalerFooterMenuItems';
import useHelmet from 'utilities/hooks/helmet/useHelmet';
import useHiddenBodyScroll from 'utilities/hooks/hiddenBodyScroll/useHiddenBodyScroll';

function FullLayout() {
  useHelmet('حجره');
  const {pathname} = useLocation();

  useHiddenBodyScroll();

  useEffect(() => {
    document.body.className = 'theme-wholesaler';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <>
      <div className=" h-full  bg-gradient-to-b via-[#F9F9F9] from-white">
        <div className=" h-screen flex flex-col theme-wholesaler relative mx-3">
          <motion.div
            key={pathname}
            initial={{opacity: 0, x: '100%'}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: '-100%'}}
            transition={{duration: 0.2}}
            className=" grow"
          >
            <div className="grow mb-20">
              <Outlet />
            </div>
          </motion.div>
          <Footer menus={wholesalerMenus} isFarm={false} />
        </div>
      </div>
    </>
  );
}

export default FullLayout;
